<div class="d-flex align-items-center gap-2">
  <img [src]="flagPath" alt="bandeira" width="24" height="18" />
  <span class="fw-semibold d-none d-sm-inline">{{ gmtLabel }}</span>
</div>
